module.exports = __webpack_public_path__ + "static/media/facebook.1a0a5452.svg";